import { PLATFORM } from 'aurelia-pal';
import { olapicSSOClient } from 'olapic-sso-client';

class AppSession {
  constructor(eventAggregator, appConfiguration, SESSION_EVENTS) {
    'inject';

    this._eventAggregator = eventAggregator;
    this._appConfiguration = appConfiguration;
    this._SESSION_EVENTS = SESSION_EVENTS;

    this._configureSSOClient();
  }
  isAuthenticated() {
    return olapicSSOClient.isAuthenticated();
  }
  load() {
    return this.isAuthenticated();
  }
  authenticate() {
    olapicSSOClient.setConfig({
      callback: PLATFORM.location.href,
    });

    return olapicSSOClient.authenticate();
  }
  signout() {
    return olapicSSOClient.signout();
  }
  getSession() {
    return olapicSSOClient.getSession();
  }
  onSessionLoaded(fn) {
    return this._subscribe(olapicSSOClient.EVENTS.session.load, fn);
  }
  onSessionChange(fn) {
    return this._subscribe(olapicSSOClient.EVENTS.session.change, fn);
  }
  onSessionCreated(fn) {
    return this._subscribe(olapicSSOClient.EVENTS.session.creationSuccess, fn);
  }
  onSessionCreationStarts(fn) {
    return this._subscribe(olapicSSOClient.EVENTS.session.creationStart, fn);
  }
  onSessionCreationFinishes(fn) {
    return this._subscribe(olapicSSOClient.EVENTS.session.creationFinish, fn);
  }
  onSessionInterrupted(fn) {
    return this._subscribeOnce(olapicSSOClient.EVENTS.session.interrupted, fn);
  }
  onSessionEnd(fn) {
    return this._subscribeOnce(olapicSSOClient.EVENTS.session.end, fn);
  }
  onSessionUnauthorizedToken(fn) {
    return this._eventAggregator.subscribeOnce(this._SESSION_EVENTS.unauthorized, fn);
  }
  _configureSSOClient() {
    const sso = this._appConfiguration.get('sso');
    olapicSSOClient.setClientConfig({
      api: {
        url: sso.url,
      },
    });
    olapicSSOClient.setConfig(sso.settings);
  }
  _subscribe(eventName, fn) {
    return this._wrap(olapicSSOClient.on(eventName, fn));
  }
  _subscribeOnce(eventName, fn) {
    return this._wrap(olapicSSOClient.once(eventName, fn));
  }
  _wrap(subscription) {
    return {
      dispose: subscription,
    };
  }
}

export { AppSession };
